import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomPaginationTable from '../../components/table/CustomPaginationTable';
import {
  fetchEsimQuery,
  setQueryParams,
  setPagination,
  exportEsimQuery
} from '../../redux/esimQuerySlice';
import './ViewEsim.css';

function ViewEsim() {
  const dispatch = useDispatch();
  const {
    data,
    loading,
    pagination,
    queryParams,
    exportLoading
  } = useSelector(state => state.esimQuery);

  const [statusFilter, setStatusFilter] = useState('');

  const fetchData = useCallback(() => {
    const params = {
      page: pagination.pageNumber,
      size: pagination.pageSize,
      ...(statusFilter && { status: statusFilter }),
      ...queryParams
    };
    dispatch(fetchEsimQuery(params));
  }, [dispatch, pagination.pageNumber, pagination.pageSize, statusFilter, queryParams]);

  useEffect(() => {
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [fetchData]);

  const handleStatusChange = (value) => {
    setStatusFilter(value);
    const newQueryParams = { ...queryParams };

    if (value) {
      newQueryParams.status = value;
    } else {
      delete newQueryParams.status;
    }

    dispatch(setQueryParams(newQueryParams));
    dispatch(setPagination({ pageNumber: 0 }));
  };

  const handlePageChange = (page) => {
    dispatch(setPagination({ pageNumber: page - 1 }));
  };

  const handlePerRowsChange = (newPerPage) => {
    dispatch(setPagination({ pageSize: newPerPage, pageNumber: 0 }));
  };

  const handleExport = () => {
    const exportParams = {
      ...(statusFilter && { status: statusFilter }),
      ...queryParams
    };
    dispatch(exportEsimQuery(exportParams));
  };

  const columns = [
    {
      name: 'MSISDN',
      selector: row => row.msisdn,
    },
    {
      name: 'ICCID',
      selector: row => row.iccid,
    },
    {
      name: 'Status',
      selector: row => row.status,
    },
  ];

  return (
    <div className='view-esim-container'>
      <div className='view-esim-content'>
        <div className="view-esim-header">
          <h3>View Esim</h3>
          <button
            className="view-esim-export-btn"
            onClick={handleExport}
            disabled={loading || exportLoading || !data?.length}
          >
            {exportLoading ? 'EXPORTING...' : 'EXPORT'}
          </button>
        </div>

        <div className="view-esim-filter-section">
          <div className="view-esim-filter-form">
            <div className="view-esim-form-group">
              <select
                value={statusFilter}
                onChange={(e) => handleStatusChange(e.target.value)}
                className="view-esim-select"
              >
                <option value="">All</option>
                <option value="free">Free</option>
                <option value="used">Used</option>
                <option value="locked">Locked</option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <CustomPaginationTable
            data={data || []}
            totalRows={pagination.totalRecords || 0}
            loading={loading}
            perPage={pagination.pageSize}
            currentPage={pagination.pageNumber + 1}
            onPageChange={handlePageChange}
            columns={columns}
            onPerRowsChange={handlePerRowsChange}
            isHiddenPag={false}
          />
        </div>
      </div>
    </div>
  );
}

export default ViewEsim;